export default {
	SiteTitle : 'PocketBox'
}